module.exports = __webpack_public_path__ + "img/liborui.1d95e6a6.png";